var _excluded = ["children", "disabled", "error", "errorMessage", "fieldSize", "fieldWidth", "id", "label", "labelledBy", "message", "name", "placeholder", "required", "tabIndex", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*

DEPRECATED - replaced by SelectMenu in February 2022

*/

import React from 'react';
import styled from 'styled-components';
import FieldError from "../FieldError/FieldError.js";
import FieldLabel from "../FieldLabel/FieldLabel.js";
import FieldMessage from "../FieldMessage/FieldMessage.js";
var getFieldWidthValue = fieldWidth => {
  var fieldWidthValue = '100%';
  if (fieldWidth === 'auto') {
    fieldWidthValue = 'auto';
  } else if (typeof fieldWidth === 'number') {
    fieldWidthValue = "".concat(fieldWidth, "px");
  }
  return fieldWidthValue;
};
var StyledSelect = styled.select.withConfig({
  componentId: "CL__sc-1e8hs2u-0"
})(["appearance:none;display:block;cursor:pointer;background:var(--main-bkg-color);color:var(--field-text-color);position:relative;box-shadow:none;outline:none;width:", ";border:1px solid var(--field-border-color);border-radius:var(--border-radius-x-small);transition:border-color var(--hover-transition);background-image:url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22448%22%20height%3D%22512%22%20viewBox%3D%220%200%20448%20512%22%3E%3Cpath%20fill%3D%22%2371758a%22%20d%3D%22M207.029%20381.476L12.686%20187.132c-9.373-9.373-9.373-24.569%200-33.941l22.667-22.667c9.357-9.357%2024.522-9.375%2033.901-.04L224%20284.505l154.745-154.021c9.379-9.335%2024.544-9.317%2033.901.04l22.667%2022.667c9.373%209.373%209.373%2024.569%200%2033.941L240.971%20381.476c-9.373%209.372-24.569%209.372-33.942%200z%22%2F%3E%3C%2Fsvg%3E');background-repeat:no-repeat,repeat;", " ", " ", " &:not(:disabled):hover{box-shadow:none;border-color:var(--highlight-color);}&:not(:disabled):focus-visible{box-shadow:0 0 5px var(--highlight-color);border-color:var(--highlight-color);}::placeholder{color:var(--gray-5);opacity:1;font:inherit;}&::selection{background:var(--highlight-color);color:var(--main-bkg-color);}&::-moz-focus-inner{margin-top:-2px;margin-bottom:-2px;border:0;padding:0;}&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus-visible{-webkit-text-fill-color:var(--main-bkg-color);box-shadow:0 0 0 1000px var(--main-bkg-color) inset;}", " ", ""], _ref => {
  var {
    fieldWidth
  } = _ref;
  return getFieldWidthValue(fieldWidth);
}, _ref2 => {
  var {
    fieldSize
  } = _ref2;
  return fieldSize === 'large' ? "\n      height: var(--spacing-8);\n      padding: var(--spacing-2) var(--spacing-8) var(--spacing-2) var(--spacing-3);\n      font: var(--body-text-medium);\n      background-position: right var(--spacing-3) top 50%, 0 0;\n      background-size: var(--spacing-2) auto, 100%;\n    " : "";
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return fieldSize === 'medium' ? "\n    height: var(--spacing-6);\n    padding: var(--spacing-1) 33px var(--spacing-1) 15px;\n    font: var(--body-text-small);\n    background-position: right var(--spacing-2) top 50%, 0 0;\n    background-size: calc(var(--spacing-1) * 1.5) auto, 100%;\n  " : "";
}, _ref4 => {
  var {
    fieldSize
  } = _ref4;
  return fieldSize === 'small' ? "\n    height: var(--spacing-4);\n    padding: 3px var(--spacing-3) 3px 9px;\n    font: var(--body-text-x-small);\n    background-position: right var(--spacing-1) top 50%, 0 0;\n    background-size: var(--spacing-1) auto, 100%;\n  " : "";
}, _ref5 => {
  var {
    error
  } = _ref5;
  return error && "\n  border-color: var(--error-color);\n\n  &:not(:disabled):hover {\n    border-color: var(--error-color);\n  }\n\n  &:not(:disabled):focus-visible {\n    box-shadow: 0 0 5px var(--error-color);\n    border-color: var(--error-color);\n  }\n";
}, _ref6 => {
  var {
    disabled
  } = _ref6;
  return disabled && "\n  background-color: var(--surface-bkg-color);\n  border-color: var(--border-color-dim);\n";
});
var Select = _ref7 => {
  var {
      children,
      disabled = false,
      error = false,
      errorMessage = "There's an error with this field",
      fieldSize = 'medium',
      fieldWidth = 'full',
      id = '',
      label,
      labelledBy,
      message,
      name = '',
      placeholder = '',
      required = false,
      tabIndex = 0,
      value
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded);
  console.warn('[Select Component] Select is deprecated. Use SelectMenu.');
  return /*#__PURE__*/React.createElement("div", null, label && /*#__PURE__*/React.createElement(FieldLabel, {
    fieldSize: fieldSize,
    htmlFor: id,
    required: required
  }, label), /*#__PURE__*/React.createElement(StyledSelect, _extends({
    "aria-label": label,
    "aria-labelledby": labelledBy,
    disabled: disabled,
    error: error,
    fieldSize: fieldSize,
    fieldWidth: fieldWidth,
    id: id,
    name: name,
    placeholder: placeholder,
    required: required,
    tabIndex: tabIndex,
    value: value
  }, props), children), message && !error && /*#__PURE__*/React.createElement(FieldMessage, {
    fieldSize: fieldSize,
    htmlFor: id
  }, message), errorMessage && error && /*#__PURE__*/React.createElement(FieldError, {
    fieldSize: fieldSize,
    htmlFor: id
  }, errorMessage));
};
export default Select;